<div class="col-12 d-inline-flex p-3" [ngClass]="[isModal ? 'd-flex justify-content-end' : '' ]">
  <div>
    <button class="mwp-button" (click)="fileUploadInput.click()" [disabled]="isButtonDisabled">
      {{ buttonName }}
    </button>
    <input hidden #fileUploadInput type="file" multiple (change)="uploadDocuments($event)">
  </div>
  @if (displayFileSizeText) {
  <div class="ms-3">
    <span>
      <mwp-text-translate text="The following file types are accepted: .pdf, .png, .jpg, .jpeg. Each file must be smaller than 5MB and total file size less than 25MB." jsonKey="fileUpload3" />
    </span>
  </div>
  }
</div>
@if (uploadErrorMessage) {
<div class="col-12 mb-2 error">
  <span>{{ uploadErrorMessage }}
  </span>
</div>
}
<div>
  <div class="px-3">
    <hr class="m-0">
    <div>
      <mwp-table [tableColumns]="filesColumns" [dataSource]="filesMatTableData" (emitButtonSelection)="deleteDocument($event)" [isModal]="true" />
    </div>
  </div>
  <div class="table-total pe-3">
    <mwp-text-translate text="Total File Size: " jsonKey="fileUpload12" />
    &nbsp; {{ totalSize }}
  </div>
</div>
@if (isOutOfDownloadRange) {
<div class="error mb-2">
  <span>
    <mwp-text-translate text="Total File Size is larger than 25MB. Please remove files to bring the total size below 25MB." jsonKey="fileUpload13" />
  </span>
</div>
}